import { Magnitude } from 'domain/entity/magnitude';
import getGenericUseCase from 'use-case/genericUseCase';
import ReadMagnitudesCriteria from 'use-case/magnitudes/read/readMagnitudesCriteria';

const getReadMagnitudesUseCase = getGenericUseCase<Magnitude[], ReadMagnitudesCriteria>((client, criteria) => client(criteria));

export default getReadMagnitudesUseCase;
